import React from "react";
import { useMastery } from "../context/MasteryContext";
import { useAuth } from "../context/AuthContext";
import { useT } from "../context/LanguageContext";
import { Trophy } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Inline trophy pill for the sticky footer strip. Keeps the same shape & info
 * as the old floating badge but lives in the document flow on the right side
 * of the footer so it never overlaps content.
 *
 * The standalone fixed/floating variant has been retired in favour of this one
 * (see Layout.jsx footer strip).
 */
export default function TrophyBadge() {
  const { user } = useAuth();
  const { mastery } = useMastery() || {};
  const t = useT();
  if (!user || !mastery) return null;
  const isStudent = user.role === "student";
  const to = isStudent ? "/student/scales" : "/teacher/my-scales";

  return (
    <Link
      to={to}
      data-testid="trophy-badge"
      className="select-none group shrink-0"
      title={`${mastery.scales}/${mastery.scales_total} ${t("scales mastered")} · ${mastery.songs} ${t("songs mastered")}`}
    >
      <div
        className="flex items-center gap-2 pl-2 pr-3 py-1 rounded-full shadow-md transition-transform group-hover:-translate-y-0.5"
        style={{
          background: "linear-gradient(135deg, #FFE28A 0%, #FFB703 60%, #E09A00 100%)",
          border: "2px solid #E09A00",
          color: "#3d2a00",
        }}
      >
        <Trophy className="w-4 h-4" style={{ color: "#7a5a00" }} />
        <div className="leading-none">
          <span className="font-display font-black text-sm" data-testid="trophy-total">{mastery.total}</span>
          <span className="text-[9px] uppercase tracking-widest font-bold opacity-80 ml-1.5">{t("Mastered")}</span>
        </div>
        <div className="ml-1 pl-2 border-l leading-none hidden sm:flex items-baseline gap-1" style={{ borderColor: "rgba(122,90,0,0.4)" }}>
          <span className="text-[9px] uppercase tracking-widest font-bold opacity-80">{t("Scales")}</span>
          <span className="font-display font-black text-sm">{mastery.scales}<span className="opacity-70 font-semibold text-[10px]">/{mastery.scales_total}</span></span>
        </div>
        <div className="pl-2 border-l leading-none hidden sm:flex items-baseline gap-1" style={{ borderColor: "rgba(122,90,0,0.4)" }}>
          <span className="text-[9px] uppercase tracking-widest font-bold opacity-80">{t("Songs")}</span>
          <span className="font-display font-black text-sm">{mastery.songs}</span>
        </div>
      </div>
    </Link>
  );
}
